import React from "react";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
import MDInput from "../MDInput";
import MDSelect from "../MDSelect";
import MDButton from "../MDButton";
import Card from "@mui/material/Card";
import { ReactSortable } from "react-sortablejs";
import EditBuilderForm from "./EditBuilderForm";
import Loader from "../../Loader";
import QuillEditor from "../QuillEditor";
import AlertComponent from  "../Modals/Alert";
import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from "@mui/icons-material/Edit";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from '@mui/material/styles';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import "../../styles/formbuilder.scss";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

interface FormProps {
    formBuilder?: boolean;
    formType: string;
    form: any;
    data?: any;
    item?: any;
    onFormChange?: Function;
    onFormCancel?: Function;
    onFormSave?: Function;
    onSuccess?: Function;
    onCancel?: Function;
    saving?: boolean;
    disabled?: boolean;
    buttons?: null | React.ReactNode;
    uploadingFiles?: boolean;
    savingText?: null | string;
    saveButtonText?: null | string;
    [key: string]: any;
}

const FormWizard = (props: FormProps) => { 
    const { item, formBuilder, formType, form, data, onFormChange, onFormCancel, onFormSave, saving, disabled, buttons, savingText, saveButtonText } = props;
    let defaultState = {
        Id: "",
        item: null,
        saving: false,
        hasModifiedFields: false,
        form: form,
        openMenu: false,
        currentFormTab: 0,
        currentForm: null,
        ...data,
        prepareItem: false,
        fieldRemoveModal: false,
        fieldRemoveMessage: null
    };
    if(item !== null){
        defaultState = {
            ...defaultState,
            ...item,
            item: item
        };
    }
    const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
    const layoutRef = React.useRef<any>(null);
    const tabRef = React.useRef<any>(null);
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    React.useEffect(() => {
        if(item !== null){
            let newState = state;
            form.map((item) => {
                item.fields.map((field) => {
                    const fieldType = field.fieldType;
                    if(fieldType === 'PICKLIST' || fieldType === 'REFERENCE'){
                        newState[field.apiName] = getPicklistValue(field, newState);
                    }
                });
            });
            setState(newState);
        }
    }, [item]);
    React.useEffect(() => {
        if(form !== null){
            let newState = state;
            let updateState = false;
            form.map((item) => {
                item.fields.map((field) => {
                    const fieldType = field.fieldType;
                    if(fieldType === 'HTML' && !state.hasOwnProperty(field.apiName+'Ref')){
                        newState[field.apiName+'Ref'] = React.createRef();
                        newState[field.apiName+'ValueRef'] = React.createRef();
                        updateState = true;
                    }
                });
            });
            if(updateState){
                setState(newState);
            }
        }
    }, [form]);
    function handleChange(event, name){
        if(formBuilder){
            return;
        }
        const value = event.target.value;
        setState({
            [name]: value,
            hasModifiedFields: true
        });
    }
    function handleTextChange(value, subForm, index, field, fieldKey){
        let form = state.form;
        if(field.apiName.length <= 0){
            const apiName = Math.floor((Math.random()*1000));
            field['apiName'] = field.fieldType+apiName;
        }
        if(field && field.hasOwnProperty("value") && field.value === value){

        }
        field['value'] = value;
        subForm.fields[fieldKey] = field;
        form[index] = subForm;
        setState({
            form: form,
            hasModifiedFields: true
        });
    }
    function handleFileChange(files, subForm, index, field, fieldKey){
        let form = state.form;
        if(field.apiName.length <= 0){
            const apiName = Math.floor((Math.random()*1000));
            field['apiName'] = field.fieldType+apiName;
        }
        subForm.fields[fieldKey] = field;
        form[index] = subForm;
        setState({
            form: form,
            [field.apiName]: files,
            hasModifiedFields: true
        });
	}
    function isFieldValid(field){
        let value = state[field.apiName];
        let isValid = true;
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'STRING':
            case 'EMAIL':
            case 'ID':
            case 'PHONE':
            case 'TEXTAREA':
            case 'DATETIME':
            case 'TEXT':
            case 'DATETIME-LOCAL':
            case 'DATE-LOCAL':
            case 'TIME-LOCAL':
                if(field.isRequired && (typeof(value) !== "string" || value.length <= 0)){
                    isValid = false;
                }
                break;
            case 'PICKLIST':
            case 'REFERENCE':
                if(value && typeof(value) === "object"){
                    value = value.label;
                }
                if(field.isRequired && (typeof(value) !== "string" || value.length <= 0)){
                    isValid = false;
                }
                break;
            case 'BOOLEAN':
            case 'CHECKBOX':
                if(field.isRequired && (value !== true)){
                    isValid = false;
                }
                break;
            case 'URL':
                if(field.isRequired && (typeof(value) !== "string" || value.length <= 0)){
                    isValid = false;
                }                
                if(typeof(value) === "string" && value.length > 0){
                    const urlMatch = value.match(urlRegex);
                    if((urlMatch === null || urlMatch.length <= 0)){
                        isValid = false;
                    }
                }
                break;
            default:
                break;
        }
        return isValid;
    }
    function isFormValid(){
        let isValid = true;
        form.map((form) => {
            form.fields.map((field) => {
                if(!isFieldValid(field)){
                    isValid = false;
                }
                return null;
            });
        });
        return isValid;
    }
    function isTabValid(tab = null){
        if(!tab){
            tab = state.currentFormTab;
        }
        let isValid = true;
        form[tab].fields.map((field) => {
            if(!isFieldValid(field)){
                isValid = false;
            }
            return null;
        });
        return isValid;
    }
    function getPicklistValue(field, newState){
        let value = newState[field.apiName];
        let picklists = field.picklistOptions;
        const isDependentPicklist = field.isDependentPicklist;
        if(isDependentPicklist && field.controllingPicklist.length > 0){
            let fieldValue = newState[field.controllingPicklist];
            if(fieldValue && typeof(fieldValue) === "object"){
                fieldValue = fieldValue.label;
            }
            if(fieldValue && picklists.hasOwnProperty(fieldValue)){
                picklists = picklists[fieldValue];
            }
        }

        if(!Array.isArray(picklists)){
            return value;
        }
        picklists.map(item => {
            // Handle for dependent fields
            if(typeof(item) === "string"){
                if(item === value){
                    value = {
                        label: item,
                        inputValue: item
                    };
                }
            }else{
                let inputValue = item.label;
                if(item.hasOwnProperty("value")){
                    inputValue = item.value;
                }
                if(inputValue === value){
                    value = {
                        label: item.label,
                        inputValue: inputValue
                    };
                }
            }
            return null;
        });
        return value;
    }
    function getPicklist(field){
        let picklists = field.picklistOptions;
        const isDependentPicklist = field.isDependentPicklist;
        if(isDependentPicklist && field.controllingPicklist.length > 0){
            let fieldValue = state[field.controllingPicklist];
            if(fieldValue && typeof(fieldValue) === "object"){
                fieldValue = fieldValue.label;
            }
            if(fieldValue && picklists.hasOwnProperty(fieldValue)){
                picklists = picklists[fieldValue];
            }
        }

        if(!Array.isArray(picklists)){
            return [];
        }
        const list = [];
        picklists.map(item => {
            // Handle for dependent fields
            if(typeof(item) === "string"){
                list.push({
                    label: item,
                    inputValue: item
                });
                return null;
            }
            let inputValue = item.label;
            if(item.hasOwnProperty("value")){
                inputValue = item.value;
            }
            list.push({
                label: item.label,
                inputValue: inputValue
            });
            return null;
        });
        return list;
    }
    function getDependingField(fields, field){
        let fieldName = null;
        fields.map((item) => {
            if(item.isDependentPicklist && item.controllingPicklist === field.apiName){
                fieldName = item.apiName;
            }
            return null;
        });
        return fieldName;
    }
    function onStepRemove(index){
        let form = state.form;
        delete form[index];
        let newForm = [];
        form.map((item) => {
            newForm.push(item);
        });
        setState({
            form: newForm,
            currentFormTab: 0,
            currentForm: null
        });
    }
    function onFieldRemove(subForm, fieldIndex){
        const { currentFormTab } = state;
        const currentForm = state.form[currentFormTab];
        const currentField = subForm.fields[fieldIndex];
        let conditionalField = false;
        let fieldRemoveMessage = null;
        state.form.map((formItem) => {
            if(formItem.conditionalStep && formItem.conditionalField === currentField.apiName && currentForm.heading === formItem.conditionalStepValue){
                conditionalField = true;
                fieldRemoveMessage = "'"+formItem.heading+"' step has dependency on field '"+currentField.label+"'. Please remove dependency before removing field.";
            }
        });
        if(conditionalField){
            setState({
                fieldRemoveModal: true,
                fieldRemoveMessage: fieldRemoveMessage
            });
            return;
        }
        delete subForm.fields[fieldIndex];
        let newFields = [];
        subForm.fields.map((item) => {
            newFields.push(item);
        });
        state.form[state.currentFormTab].fields = newFields;

        setState({
            form: state.form
        });

        if(formBuilder){
            onFormChange(state.form);
        }
    }
    function onLayoutDrop(data, layout, index, layoutIndex){
        let form = state.form;
        let newState = {};
        let layoutCopy = null;
        let apiName = null;
        switch(layout.fieldType){
            case 'PANEL':
                if(form.length === 1 && form[0].heading === null){
                    form[0].heading = 'Page 1';
                }else{
                    form.push({
                        heading: 'Page '+(form.length + 1),
                        fields: []
                    });
                }
                break;
            case 'TEXT':
            case 'FILE':
            case 'MULTIPLEFILE':
                layoutCopy = Object.assign({}, layout);
                layoutCopy.value = '';
                apiName = Math.floor((Math.random()*1000));
                layoutCopy['apiName'] = layout.fieldType+apiName;

                data[layoutIndex] = layoutCopy;
                form[index].fields = data;
                break;
            case 'HTML':
                layoutCopy = Object.assign({}, layout);
                layoutCopy.value = '';
                apiName = Math.floor((Math.random()*1000));
                layoutCopy['apiName'] = layout.fieldType+apiName;

                data[layoutIndex] = layoutCopy;
                form[index].fields = data;
                newState[layoutCopy.apiName+'Ref'] = React.createRef();
                newState[layoutCopy.apiName+'ValueRef'] = React.createRef();
                // field.value
                break;
            default:
                break;
        }
        newState['form'] = form;
        setState(newState);
    }
    function onFormTabChange(tab){
        if(formBuilder === false && disabled === false){
            return;
        }
        let newState = {
            currentFormTab: parseInt(tab)
        };
        if(tab === 9999 || tab === "9999"){
            let form = state.form;
            form.push({
                heading: 'Page '+(form.length + 1),
                fields: [],
                conditionalStep: false,
                conditionalStepValue: null,
                conditionalField: null,
                conditionalFieldValue: [],
            });
            newState['form'] = form;
            newState['currentFormTab'] = state.currentFormTab;
        }
        setState(newState);
    }
    function onEditForm(form){
        setState({
            currentForm: form
        });
    }
    function onCancelForm(){
        setState({
            currentForm: null
        });
    }    
    function onFormSuccess(item){
        let form = state.form;
        const currentForm = form[state.currentFormTab];
        currentForm.heading = item.heading;
        currentForm.conditionalStep = item.conditionalStep;
        if(item.conditionalStepValue && item.conditionalStepValue.inputValue){
            currentForm.conditionalStepValue = item.conditionalStepValue.inputValue;
        }
        if(item.conditionalField && item.conditionalField.inputValue){
            currentForm.conditionalField = item.conditionalField.inputValue;
        }
        if(item.conditionalFieldValue && item.conditionalFieldValue){
            currentForm.conditionalFieldValue = item.conditionalFieldValue;
        }
        currentForm.conditionalSubField = item.conditionalSubField;
        if(item.conditionalSubFieldValue && item.conditionalSubFieldValue.inputValue){
            currentForm.conditionalSubFieldValue = item.conditionalSubFieldValue.inputValue;
        }else{
            currentForm.conditionalSubFieldValue = null;
        }
        form[state.currentFormTab] = currentForm;
        setState({
            form: form,
            currentForm: null
        });
    }
    function hasPrevious(){
        const { currentFormTab } = state;
        if(currentFormTab > 0){
            return true;
        }
        return false;
    }
    function onPrevious(){
        const { currentFormTab } = state;
        if(!hasPrevious()){
            return;
        }
        let tabFound = false;
        let previousTab = (currentFormTab - 1);
        for(let index = form.length; index >= 0;index--){
            const subForm = form[index];
            if(index >= currentFormTab){
                continue;
            }
            previousTab = index;
            if(subForm.conditionalStep){
                if(state.hasOwnProperty(subForm.conditionalField) && state[subForm.conditionalField]){
                    const fieldValue = state[subForm.conditionalField];
                    let valueFound = false;
                    if(Array.isArray(subForm.conditionalFieldValue)){
                        subForm.conditionalFieldValue.map((parentValue) => {
                            if(parentValue.inputValue === fieldValue.inputValue){
                                valueFound = true;
                            }
                        });
                    }
                    if(typeof(fieldValue) === "object" && valueFound){
                        if(subForm.conditionalSubField !== null){
                            const subFieldValue = state[subForm.conditionalSubField];
                            if(typeof(subFieldValue) === "object" && subFieldValue.inputValue === subForm.conditionalSubFieldValue){
                                tabFound = true;
                                break;
                            }
                        }else{
                            tabFound = true;
                            break;
                        }
                    }
                }
            }else{
                tabFound = true;
                break;
            }
        }
        console.log("previousTab", previousTab);
        setState({
            currentFormTab: previousTab
        });
    }
    function hasNext(validate = false){
        if(validate){
            const isValid = isTabValid();
            if(!isValid){
                return false;
            }
        }
        const { currentFormTab } = state;
        const nextTab = getNextTab();
        if(currentFormTab < nextTab){
            return true;
        }
        return false;
    }

    function getNextTab(){
        let form = state.form;
        const { currentFormTab } = state;
        let nextTab = currentFormTab;
        let nextTabFound = false;
        let conditionalStep = false;
        form.map((subForm, index) => {
            if(nextTabFound){
                return null;
            }
            if(subForm.conditionalStep){
                conditionalStep = true;
                if(state.hasOwnProperty(subForm.conditionalField) && state[subForm.conditionalField]){
                    const fieldValue = state[subForm.conditionalField];
                    let valueFound = false;
                    if(Array.isArray(subForm.conditionalFieldValue)){
                        subForm.conditionalFieldValue.map((parentValue) => {
                            if(parentValue.inputValue === fieldValue.inputValue){
                                valueFound = true;
                            }
                        });
                    }
                    if(typeof(fieldValue) === "object" && valueFound){
                        if(subForm.conditionalSubField !== null){
                            const subFieldValue = state[subForm.conditionalSubField];
                            if(typeof(subFieldValue) === "object" && subFieldValue.inputValue === subForm.conditionalSubFieldValue){
                                nextTab = index;
                                if(nextTab > currentFormTab){
                                    nextTabFound = true;
                                }
                            }
                        }else{
                            nextTab = index;
                            if(nextTab > currentFormTab){
                                nextTabFound = true;
                            }
                        }                        
                    }
                }
            }else if(nextTab !== index){
                nextTab = index;
                if(nextTab > currentFormTab){
                    nextTabFound = true;
                }
            }
        });
        if(!formBuilder && formType === "wizard"){
            if(currentFormTab === nextTab){
                nextTab = form.length;
            }
        }
        return nextTab;
    }
    
    function onNext(){
        if(!hasNext(true)){
            return;
        }
        const nextTab = getNextTab();
        
        setState({
            currentFormTab: nextTab
        });
    }
    async function onSuccess(){
        if(!isFormValid()){
            return;
        }
        if(disabled === true){
            return props.onCancel();
        }
        let data = {};
        let files = [];
        for(let formIndex = 0; formIndex < form.length; formIndex++){
            let fields = form[formIndex].fields;
            for(let fieldIndex = 0; fieldIndex < fields.length; fieldIndex++){
                const field = fields[fieldIndex];
                let fieldValue = state[field.apiName];
                if(field.fieldType === 'FILE' || field.fieldType === 'MULTIPLEFILE'){
                    if(fieldValue && typeof(fieldValue) === "object"){
                        for(let i = 0; i < fieldValue.length; i++){
                            const file = fieldValue[i];
                            files.push(file);
                        }
                    }
                }else{
                    if(fieldValue && typeof(fieldValue) === "object"){
                        fieldValue = fieldValue.inputValue;
                    }
                    data[field.apiName] = fieldValue;
                }
            }
        }
        props.onSuccess(data, files);
    }
    function isTabEnabled(subForm){
        if(formBuilder){
            return true;
        }
        if(!subForm.conditionalStep){
            return true;
        }
        if(state.hasOwnProperty(subForm.conditionalField) && state[subForm.conditionalField]){
            const fieldValue = state[subForm.conditionalField];
            let valueFound = false;
            if(Array.isArray(subForm.conditionalFieldValue)){
                subForm.conditionalFieldValue.map((parentValue) => {
                    if(parentValue.inputValue === fieldValue.inputValue){
                        valueFound = true;
                    }
                });
            }
            if(typeof(fieldValue) === "object" && valueFound){
                if(subForm.conditionalSubField !== null){
                    const subFieldValue = state[subForm.conditionalSubField];
                    if(typeof(subFieldValue) === "object" && subFieldValue.inputValue === subForm.conditionalSubFieldValue){
                        return true;
                    }else{
                        return false;
                    }
                }
                return true;
            }
            return false;
        }
        return false;
    }
    function renderField(subForm, index, field, fieldKey){
        const fields = subForm.fields;
        let fieldValue = state[field.apiName];
        if(typeof(fieldValue) === "undefined"){
            fieldValue = "";
        }
        let fieldElement = null;
        const isDependentPicklist = field.isDependentPicklist;
        if(formBuilder === false && isDependentPicklist && field.controllingPicklist.length > 0){
            const parentValue = state[field.controllingPicklist];
            if(!parentValue || parentValue.length <= 0){
                return null;
            }
        }
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'STRING':
            case 'EMAIL':
            case 'ID':
            case 'PHONE':
            case 'TEXT':
            case 'URL':
                let inputType = 'text';
                if(fieldType === 'EMAIL'){
                    inputType = 'email';
                }
                if(fieldType === 'PHONE'){
                    inputType = 'tel';
                }
                fieldElement = (
                    <MDInput
                        type={inputType}
                        label={field.label}
                        fullWidth
                        value={fieldValue}
                        required={field.isRequired}
                        onChange={(event) => handleChange(event, field.apiName)}
                        disabled={(disabled === true)}
                        // disabled={formBuilder}
                        // disabled={(state.Id.length > 0)}
                    />
                );
                break;
            case 'TEXTAREA':
            case 'LONGTEXT':
                fieldElement = (
                    <MDInput
                        label={field.label}
                        fullWidth
                        value={fieldValue}
                        required={field.isRequired}
                        onChange={(event) => handleChange(event, field.apiName)}
                        disabled={(disabled === true)}
                        // readOnly={formBuilder}
                        // disabled={(state.Id.length > 0)}
                        multiline
                        rows={3}
                    />
                );
                break;
            case 'PICKLIST':
            case 'REFERENCE':
                const options = getPicklist(field);
                let selectProps: any = {};
                if(formBuilder){
                    selectProps = {
                        open: false
                    };
                }
                if(fieldValue && typeof(fieldValue) === "object"){
                    fieldValue = fieldValue.label;
                }
                fieldElement = (
                    <MDSelect
                        defaultValue={fieldValue}
                        value={fieldValue}
                        required={field.isRequired}
                        // readOnly={formBuilder}
                        // disabled={(state.Id.length > 0)}
                        options={options}
                        label={field.label}
                        {...selectProps}
                        onChange={(event, option) => {
                            if(formBuilder){
                                return;
                            }
                            const fieldName = getDependingField(fields, field);
                            let newState = {};
                            if(fieldName){
                                newState[fieldName] = "";
                            }
                            newState[field.apiName] = option;
                            setState(newState);
                        }}
                        disabled={(disabled === true)}
                    />
                );
                break;
            case 'DATETIME':
            case 'DATETIME-LOCAL':
                if(fieldValue && fieldValue.length <= 0){
                    fieldValue = null;
                }
                fieldElement = (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                            <DateTimePicker
                                label={field.label}
                                className="field-datetimepicker"
                                onChange={(newValue) => {
                                    let newState = {
                                        [field.apiName]: newValue.toISOString()
                                    };
                                    setState(newState);
                                }}
                                value={(fieldValue ? dayjs(fieldValue) : null)}
                                disabled={(disabled === true)}
                                // readOnly={formBuilder}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )
                break;
            case 'DATE':
            case 'DATE-LOCAL':
                if(fieldValue && fieldValue.length <= 0){
                    fieldValue = null;
                }
                fieldElement = (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                                label={field.label}
                                className="field-datepicker"
                                onChange={(newValue) => {
                                    let newState = {
                                        [field.apiName]: newValue.toDate()
                                    };
                                    setState(newState);
                                }}
                                value={(fieldValue ? dayjs(fieldValue) : null)}
                                disabled={(disabled === true)}
                                // readOnly={formBuilder}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )
                break;
            case 'TIME':
            case 'TIME-LOCAL':
                if(fieldValue && fieldValue.length <= 0){
                    fieldValue = null;
                }
                fieldElement = (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimePicker', 'TimePicker']}>
                            <TimePicker
                                label={field.label}
                                className="field-timepicker"
                                onChange={(newValue) => {
                                    let newState = {
                                        [field.apiName]: newValue.format("HH:mm")
                                    };
                                    setState(newState);
                                }}
                                value={(fieldValue ? dayjs(fieldValue) : null)}
                                disabled={(disabled === true)}
                                // readOnly={formBuilder}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )
                break;
            case 'BOOLEAN':
            case 'CHECKBOX':
                fieldValue = state[field.apiName];
                let checkbox = null
                if(!formBuilder){
                    checkbox = <Checkbox required={field.isRequired} checked={(fieldValue === null ? false : fieldValue)} />;
                }else{
                    checkbox = <Checkbox required={field.isRequired} />;
                }
                fieldElement = (
                    <FormGroup className="field-checkbox">
                        <FormControlLabel
                            control={checkbox}
                            label={field.label}
                            onChange={(event: any) => {
                                setState({
                                    [field.apiName]: event.target.checked,
                                });
                            }}
                            checked={(fieldValue === null ? false : fieldValue)}
                            disabled={(disabled === true)}
                        />
                    </FormGroup>
                )
                break;
            case 'TEXT':
                if(formBuilder){
                    fieldElement = (
                        <MDInput
                            label={field.label}
                            fullWidth
                            value={field.value}
                            required={field.isRequired}
                            onChange={(event: any) => handleTextChange(event.target.value, subForm, index, field, fieldKey)}
                            disabled={(disabled === true)}
                            multiline
                            rows={3}
                        />
                    )
                }else{
                    fieldElement = (
                        <MDTypography variant="h6">{field.value}</MDTypography>
                    )
                }
                break;
            case 'HTML':
                if(formBuilder){
                    fieldValue = field.value;                    
                    if(!state.hasOwnProperty(field.apiName+'Ref')){
                        fieldElement = (
                            <MDTypography variant="div" sx={{fontSize: "15px"}} dangerouslySetInnerHTML={{__html: field.value}} />
                        );
                    }else{
                        const elementRef = state[field.apiName+'Ref'];
                        const defaultValueRef = state[field.apiName+'ValueRef'];
                        defaultValueRef.current = fieldValue;
                        fieldElement = (
                            <QuillEditor
                                ref={elementRef}
                                // readOnly={(disabled === true)}
                                defaultValue={defaultValueRef.current}
                                onTextChange={() => handleTextChange(elementRef.current.getSemanticHTML(), subForm, index, field, fieldKey)}
                            />
                        );
                    }
                }else{
                    fieldElement = (
                        <MDTypography variant="div" sx={{fontSize: "15px"}} dangerouslySetInnerHTML={{__html: field.value}} />
                    );
                }
                break;
            case 'FILE':
                fieldElement = (
                    <MDBox>
                        <MDButton
                            component="label"
                            variant="outlined"
                            color="info"
                            tabIndex={-1}
                            role={undefined}
                            startIcon={<FileUploadOutlinedIcon />}
                            sx={{marginRight: "8px"}}
                            disabled={(disabled === true)}
                        >
                            Select File
                            <VisuallyHiddenInput
                                type="file"
                                onChange={(event) => handleFileChange(event.target.files, subForm, index, field, fieldKey)}
                            />
                        </MDButton>
                        <span className="slds-file-selector__text" style={{fontSize: "14px"}}>
                            {
                                fieldValue !== null && typeof(fieldValue) !== "undefined" && fieldValue.length > 0 ?
                                    fieldValue[0].name
                                :
                                    ""
                            }
                        </span>
                    </MDBox>
                )
                break;
            case 'MULTIPLEFILE':
                const multipleFilesArray = [];
                if(fieldValue !== null && typeof(fieldValue) !== "undefined" && fieldValue.length > 0){
                    for(let i = 0; i < fieldValue.length; i++){
                        multipleFilesArray.push(fieldValue[i].name);
                    }
                }
                fieldElement = (
                    <MDBox>
                        <MDButton
                            component="label"
                            variant="outlined"
                            color="info"
                            tabIndex={-1}
                            role={undefined}
                            startIcon={<FileUploadOutlinedIcon />}
                            sx={{marginRight: "8px"}}
                            disabled={(disabled === true)}
                        >
                            Select Files
                            <VisuallyHiddenInput
                                type="file"
                                multiple
                                onChange={(event) => handleFileChange(event.target.files, subForm, index, field, fieldKey)}
                            />
                        </MDButton>
                        <span className="slds-file-selector__text" style={{fontSize: "14px"}}>
                            {multipleFilesArray.join(", ")}
                        </span>
                    </MDBox>
                )
                break;
            default:
                break;
        }
        return fieldElement;
    }
    function renderFields(subForm, index){
        return (
            subForm.fields.map((field, key) => {
                let fieldElement = renderField(subForm, index, field, key);
                if(!fieldElement){
                    return null;
                }
                return (
                    <MDBox className="field-drag-item" key={key} pb={1} pt={1}>
                        {fieldElement}
                        {
                            formBuilder ?
                                <MDButton
                                    variant="gradient"
                                    color="error"
                                    onClick={() => onFieldRemove(subForm, key)}
                                    iconOnly
                                    size="small"
                                    className="field-item-remove"
                                >
                                    <CloseIcon />
                                </MDButton>
                            :
                                null
                        }
                    </MDBox>
                )
            })
        )
    }
    function renderForm(formItem, index){
        return (
            <Card key={index} style={{borderRadius: "xs", display: ((state.currentFormTab === index || formType !== "wizard") ? "" : "none")}}>
                <MDBox p={2}>
                    {
                        formItem.heading && formBuilder ?
                            <MDBox mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                                {/* <MDTypography variant="h6">{formItem.heading}</MDTypography> */}
                                {
                                    formBuilder ?
                                        formType === "wizard" ?
                                            <MDBox>
                                                <MDButton
                                                    variant="gradient"
                                                    color="info"
                                                    onClick={() => onEditForm(formItem)}
                                                    iconOnly
                                                    style={{marginRight: "5px"}}
                                                    size="small"
                                                >
                                                    <EditIcon />
                                                </MDButton>
                                                {
                                                    form.length > 1 ?
                                                        <MDButton
                                                            variant="gradient"
                                                            color="error"
                                                            onClick={() => onStepRemove(index)}
                                                            iconOnly
                                                            size="small"
                                                        >
                                                            <CloseIcon />
                                                        </MDButton>
                                                    :
                                                    null
                                                }
                                            </MDBox>
                                        :
                                        null
                                    :
                                        null
                                }
                            </MDBox>
                        :
                        null
                    }
                    <MDBox className="fields-dropzone" index={index}>
                        {
                            formBuilder === false ?
                                formItem.fields.length > 0 ?
                                    renderFields(formItem, index)
                                :
                                    null
                            :
                                <ReactSortable
                                    group="shared"
                                    animation={150}
                                    list={state.form[index].fields}
                                    onAdd={(element) => {
                                        layoutRef.current = element;
                                    }}
                                    setList={(data: any) => {
                                        let form = state.form;
                                        let layout = null;
                                        let layoutIndex = 0;
                                        if(layoutRef.current !== null){
                                            layoutIndex = layoutRef.current.newIndex;
                                            layoutRef.current = null;
                                            if(form[index].fields.length === 0){
                                                layoutIndex = 0;
                                            }
                                        }
                                        const subFormFields = form[index].fields;
                                        const fieldsModified = (data.length !== subFormFields.length);
                                        let updateRequired = false;
                                        data.map((field, fieldIndex) => {
                                            if(field.hasOwnProperty("type") && field.type === "layout" && layoutIndex === fieldIndex){
                                                layout = field;
                                                layoutIndex = fieldIndex;
                                            }
                                            if(!fieldsModified){
                                                const oldField = subFormFields[fieldIndex];
                                                if(oldField && oldField.apiName !== field.apiName){
                                                    updateRequired = true;
                                                }
                                            }
                                        });
                                        // Restrict extra setList calls to avoid additional state updates
                                        if(!fieldsModified && !updateRequired){
                                            return;
                                        }
                                        if(layout !== null){
                                            return onLayoutDrop(data, layout, index, layoutIndex);
                                        }
                                        let stepFields = [];
                                        let filteredFields = [];
                                        data.map((field) => {
                                            if(stepFields.includes(field.apiName) || stepFields.indexOf(field.apiName) !== -1){
                                                return null;
                                            }
                                            stepFields.push(field.apiName);
                                            filteredFields.push(field);
                                        });
                                        form[index].fields = filteredFields;
                                        setState({form: form});

                                        if(formBuilder){
                                            onFormChange(form);
                                        }
                                    }}
                                    handle=".field-drag-item"
                                >
                                    {
                                        formItem.fields.length > 0 ?
                                            renderFields(formItem, index)
                                        :
                                            <MDBox className="drop-form field-drag-item" key={-1}>Drag and Drop a Form Component</MDBox>
                                    }
                                </ReactSortable>
                        }
                    </MDBox>
                </MDBox>
            </Card>
        )
    }
    function renderTabs(){
        let tabs = [];
        state.form.map((subForm, index) => {
            if(!isTabEnabled(subForm)){
                return null;
            }else{
                tabs.push(
                    <Tab
                        label={subForm.heading}
                        value={index}
                        key={index}
                        className={(state.currentFormTab === index ? 'Mui-selected' : '')}
                        onClick={() => onFormTabChange(index)}
                    />
                );
            }                                    
        });
        if(formBuilder){
            tabs.push(
                <Tab
                    label="+ Page"
                    value="9999"
                    className="disabled-sort"
                    key={9999}
                    onClick={() => onFormTabChange(9999)}
                />
            );
        }else if(formType === "wizard"){
            tabs.push(
                <Tab
                    label="Summary"
                    value={state.form.length}
                    className="disabled-sort"
                    key={state.form.length}
                />
            ); 
        }
        return tabs;
    }
    function renderSummaryField(subForm, index, field, fieldKey){
        const fields = subForm.fields;
        let fieldValue = state[field.apiName];
        if(typeof(fieldValue) === "undefined"){
            fieldValue = "";
        }
        let fieldElement = null;
        const isDependentPicklist = field.isDependentPicklist;
        if(formBuilder === false && isDependentPicklist && field.controllingPicklist.length > 0){
            const parentValue = state[field.controllingPicklist];
            if(!parentValue || parentValue.length <= 0){
                return null;
            }
        }
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'STRING':
            case 'EMAIL':
            case 'ID':
            case 'PHONE':
                let inputType = 'text';
                if(fieldType === 'EMAIL'){
                    inputType = 'email';
                }
                fieldElement = (
                    <MDInput
                        type={inputType}
                        label={field.label}
                        fullWidth
                        value={fieldValue}
                        required={field.isRequired}
                        onChange={(event) => handleChange(event, field.apiName)}
                        disabled={true}
                    />
                );
                break;
            case 'TEXTAREA':
                fieldElement = (
                    <MDInput
                        label={field.label}
                        fullWidth
                        value={fieldValue}
                        required={field.isRequired}
                        onChange={(event) => handleChange(event, field.apiName)}
                        disabled={true}
                        multiline
                        rows={3}
                    />
                );
                break;
            case 'PICKLIST':
            case 'REFERENCE':
                const options = getPicklist(field);
                let selectProps: any = {};
                if(formBuilder){
                    selectProps = {
                        open: false
                    };
                }
                if(fieldValue && typeof(fieldValue) === "object"){
                    fieldValue = fieldValue.label;
                }
                fieldElement = (
                    <MDSelect
                        defaultValue={fieldValue}
                        value={fieldValue}
                        required={field.isRequired}
                        options={options}
                        label={field.label}
                        {...selectProps}
                        disabled={true}
                    />
                );
                break;
            case 'DATETIME':
                fieldElement = (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                                label={field.label}
                                className="field-datepicker"
                                onChange={(event) => handleChange(event, field.apiName)}
                                value={fieldValue}
                                disabled={true}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                )
                break;
            case 'BOOLEAN':
                fieldValue = state[field.apiName];
                let checkbox = <Checkbox required={field.isRequired} />;
                if(!formBuilder){
                    checkbox = <Checkbox required={field.isRequired} checked={fieldValue} />;
                }
                fieldElement = (
                    <FormGroup className="field-checkbox">
                        <FormControlLabel
                            control={checkbox}
                            label={field.label}
                            onChange={(event: any) => {
                                setState({
                                    [field.apiName]: event.target.checked,
                                });
                            }}
                            disabled={true}
                        />
                    </FormGroup>
                )
                break;
            case 'TEXT':
                if(formBuilder){
                    fieldElement = (
                        <MDInput
                            label={field.label}
                            fullWidth
                            value={field.value}
                            required={field.isRequired}
                            onChange={(event: any) => handleTextChange(event.target.value, subForm, index, field, fieldKey)}
                            disabled={true}
                            multiline
                            rows={3}
                        />
                    )
                }else{
                    fieldElement = (
                        <MDTypography variant="h6">{field.value}</MDTypography>
                    )
                }
                break;
            case 'HTML':
                fieldElement = (
                    <MDTypography variant="div" sx={{fontSize: "15px"}} dangerouslySetInnerHTML={{__html: field.value}} />
                );
                break;
            case 'FILE':
                fieldElement = (
                    <MDBox>
                        <MDButton
                            component="label"
                            variant="outlined"
                            color="info"
                            tabIndex={-1}
                            role={undefined}
                            startIcon={<FileUploadOutlinedIcon />}
                            sx={{marginRight: "8px"}}
                            disabled={true}
                        >
                            File
                        </MDButton>
                        <span className="slds-file-selector__text" style={{fontSize: "14px"}}>
                            {
                                fieldValue !== null && typeof(fieldValue) !== "undefined" && fieldValue.length > 0 ?
                                    fieldValue[0].name
                                :
                                    ""
                            }
                        </span>
                    </MDBox>
                )
                break;
            case 'MULTIPLEFILE':
                const multipleFilesArray = [];
                if(fieldValue !== null && typeof(fieldValue) !== "undefined" && fieldValue.length > 0){
                    for(let i = 0; i < fieldValue.length; i++){
                        multipleFilesArray.push(fieldValue[i].name);
                    }
                }
                fieldElement = (
                    <MDBox>
                        <MDButton
                            component="label"
                            variant="outlined"
                            color="info"
                            tabIndex={-1}
                            role={undefined}
                            startIcon={<FileUploadOutlinedIcon />}
                            sx={{marginRight: "8px"}}
                            disabled={true}
                        >
                            Files
                        </MDButton>
                        <span className="slds-file-selector__text" style={{fontSize: "14px"}}>
                            {multipleFilesArray.join(", ")}
                        </span>
                    </MDBox>
                )
                break;
            default:
                break;
        }
        return fieldElement;
    }
    function renderSummaryFields(subForm, index){
        return (
            subForm.fields.map((field, key) => {
                let fieldElement = renderSummaryField(subForm, index, field, key);
                if(!fieldElement){
                    return null;
                }
                return (
                    <MDBox className="field-drag-item" key={key} pb={1} pt={1}>
                        {fieldElement}
                    </MDBox>
                )
            })
        )
    }
    function renderSummaryForm(formItem, index){
        return (
            <Card key={index} style={{borderRadius: "xs", marginBottom: "16px"}}>
                <MDBox p={2}>
                    <MDBox mb={2} sx={{display: "flex", justifyContent: "flex-start"}}>
                        <MDTypography variant="h6">{formItem.heading}</MDTypography>
                    </MDBox>
                    <MDBox className="fields-dropzone" index={index}>
                        {
                            formItem.fields.length > 0 ?
                                renderSummaryFields(formItem, index)
                            :
                                null
                        }
                    </MDBox>
                </MDBox>
            </Card>
        )
    }
    function renderSummaryTab(){
        let html = [];
        state.form.map((subForm, index) => {
            if(!isTabEnabled(subForm)){
                return null;
            }else{
                html.push(renderSummaryForm(subForm, index));
            }
        });
        return html;
    }
    return (
        <div className={"formbuilder builder-type-"+formType}>
            {
                formType === "wizard" ?
                    formBuilder === false ?
                        <Tabs
                            orientation="horizontal"
                            value={state.currentFormTab}
                            onChange={(event, tab) => onFormTabChange(tab)}
                            variant="standard"
                            style={{marginBottom: "16px"}}
                            // className="form-wizard-tabs"
                        >
                            {
                                state.form.map((subForm, index) => {
                                    if(!isTabEnabled(subForm)){
                                        return null;
                                    }else{
                                        return (
                                            <Tab
                                                label={subForm.heading}
                                                value={index}
                                                key={index}
                                            />
                                        )
                                    }                                    
                                })
                            }
                            {
                                formType === "wizard" ?
                                    <Tab
                                        label="Summary"
                                        value={state.form.length}
                                        key={state.form.length}
                                    />
                                :
                                    null
                            }
                        </Tabs>
                    :
                    <Tabs
                        orientation="horizontal"
                        value={0}
                        // onChange={(event, tab) => onFormTabChange(tab)}
                        variant="standard"
                        style={{marginBottom: "16px"}}
                        className="form-wizard-tabs"
                    >
                        <ReactSortable
                            group="tabs"
                            animation={150}
                            list={state.form}
                            onChoose={(event) => {
                                tabRef.current = event;
                            }}
                            setList={(data) => {
                                let tabsModified = false;
                                let newForm = [];
                                let currentFormHeading = null;
                                let currentFormTab = state.currentFormTab;
                                let tabMoved = null;
                                state.form.map((subForm, index) => {
                                    if(currentFormTab === index){
                                        currentFormHeading = subForm.heading;
                                    }
                                    if(subForm.heading !== data[index].heading){
                                        tabsModified = true;
                                    }
                                    if(tabRef.current !== null && tabRef.current.oldIndex === index){
                                        tabMoved = subForm;
                                    }
                                });
                                if(!tabsModified){
                                    return;
                                }
                                data.map((item, index) => {
                                    delete item['chosen'];
                                    delete item['selected'];
                                    if(tabMoved !== null && tabMoved.heading === item.heading){
                                        item = {
                                            ...item,
                                            conditionalStep: false,
                                            conditionalStepValue: null,
                                            conditionalField: null,
                                            conditionalFieldValue: [],
                                            conditionalSubField: null,
                                            conditionalSubFieldValue: null
                                        };
                                    }
                                    newForm.push(item);
                                    if(item.heading === currentFormHeading){
                                        currentFormTab = index;
                                    }
                                });
                                setState({form: newForm, currentFormTab: currentFormTab});
                            }}
                            // tag={SortableTabs}
                            handle=".MuiTab-root"
                            filter={'.disabled-sort'}
                            className="MuiTabs-sortableContainer"
                        >
                            {renderTabs()}
                        </ReactSortable>
                    </Tabs>
                :
                null
            }
            {
                state.form.map((subForm, index) => {
                    if(!isTabEnabled(subForm)){
                        return null
                    }else{
                        return renderForm(subForm, index)
                    }
                })
            }
            {
                state.currentFormTab === state.form.length ?
                    renderSummaryTab()
                :
                    null
            }
            {savingText}
            {
                formBuilder === false && formType === "wizard" ?
                    <MDBox pt={2} sx={{display: "flex", justifyContent: "space-between"}}>
                        {
                            state.currentFormTab !== 0 ?
                                <MDButton key="cancel" variant="gradient" color="light" disabled={!hasPrevious()} onClick={() => onPrevious()} >
                                    Previous
                                </MDButton>
                            :
                                <div>&nbsp;</div>
                        }
                        {buttons}
                        {
                            hasNext() ?
                                <MDButton key="save" variant="gradient" color="info" disabled={!hasNext(true)} onClick={() => onNext()}>
                                    Next
                                </MDButton>
                            :
                                <MDButton key="save" variant="gradient" color="info" disabled={!isFormValid()} onClick={() => onSuccess()}>
                                    {
                                        saving || state.saving ?
                                            <Loader color="white" size={20} />
                                        :
                                            (disabled !== true) ?
                                                "Finish"
                                            :
                                                "Exit"
                                    }
                                </MDButton>
                        }
                    </MDBox>
                :
                    formBuilder === false ?
                        <MDBox pt={2} sx={{display: "flex", justifyContent: "space-between"}}>
                            {
                                (disabled !== true) ?
                                    <MDButton key="cancel" variant="gradient" color="light" onClick={() => props.onCancel()} >
                                        Cancel
                                    </MDButton>
                                :
                                    <div>&nbsp;</div>
                            }
                            {buttons}
                            {
                                (disabled !== true) ?
                                    <MDButton key="save" variant="gradient" color="info" disabled={!isFormValid()} onClick={() => onSuccess()}>
                                        {
                                            saving || state.saving ?
                                                <Loader color="white" size={20} />
                                            :
                                                saveButtonText ?
                                                    saveButtonText
                                                :
                                                    "Save"
                                        }
                                    </MDButton>
                                :
                                    <div>&nbsp;</div>
                            }
                        </MDBox>
                    :
                        <MDBox ml={2} style={{textAlign: "right"}} mt={2}>
                            <MDButton variant="gradient" onClick={() => onFormCancel()} color="light" sx={{marginRight: "8px"}}>
                                Cancel
                            </MDButton>
                            <MDButton variant="gradient" color="info" onClick={() => onFormSave(state)}>
                                {
                                    saving ?
                                        <Loader color="white" size={20} />
                                    :
                                        "Save Form"
                                }
                            </MDButton>
                        </MDBox>
            }
            {
                state.currentForm !== null ?
                    <EditBuilderForm
                        open={(state.currentForm !== null)}
                        item={state.currentForm}
                        form={form}
                        onCancel={() => onCancelForm()}
                        onDelete={() => onStepRemove(state.currentFormTab)}
                        onSuccess={(item) => onFormSuccess(item)}
                        disableConditionalForm={(state.currentFormTab === 0)}
                    />
                :
                null
            }
            {
                state.fieldRemoveModal ?
                    <AlertComponent
                        open={state.fieldRemoveModal}
                        onCancel={() => setState({fieldRemoveModal: false, fieldRemoveMessage: null})}
                        onSuccess={props.onDelete}
                        message={state.fieldRemoveMessage}
                    />
                :
                null
            }
        </div>
    )
};

export { FormWizard };
export default FormWizard;
